import React, { useState, useContext } from "react"
import PropTypes from "prop-types"
import { TableRow, TableCell, Checkbox, Typography } from "@mui/material"
import { formatValue } from "react-currency-input-field"
import { getCurrency } from "utils/functions"
import AuthContext from "context/auth/authContext"

const isSelected = ({ partidaId, selectedParts }) => {
  for (let part of selectedParts) {
    if (part.partidaId === partidaId) {
      return true
    }
  }
  return false
}

const Part = ({
  part,
  selectedParts,
  setSelectedParts,
  priceField = "clientPrice",
}) => {
  const { user } = useContext(AuthContext)
  const [checked, setChecked] = useState(
    isSelected({ partidaId: part.partidaId, selectedParts }),
  )

  const effectivePrice = part[priceField] ?? 0
  const total = (part.quantity ?? 0) * effectivePrice

  const onCheck = () => {
    if (checked) {
      setSelectedParts(
        selectedParts.filter(p => p.partidaId !== part.partidaId),
      )
      setChecked(false)
    } else {
      setSelectedParts([...selectedParts, part])
      setChecked(true)
    }
  }

  const formatCurrency = value => {
    let handledValue = value ?? 0
    return formatValue({
      value: handledValue.toFixed(2),
      locale: "es-ES",
      decimalSeparator: ",",
      groupSeparator: ".",
      suffix: " " + getCurrency(user["custom:currency"]),
      decimalScale: 2,
      fixedDecimalScale: true,
    })
  }

  const formatNumber = value => {
    let handledValue = value ?? 0
    return formatValue({
      value: handledValue.toFixed(2),
      locale: "es-ES",
      decimalSeparator: ",",
      groupSeparator: ".",
      suffix: "",
      decimalScale: 2,
      fixedDecimalScale: true,
    })
  }

  return (
    <TableRow
      onClick={onCheck}
      hover
      selected={checked}
      sx={{
        cursor: "pointer",
        "& .MuiTableCell-root": {
          py: 0.5,
          px: 1,
        },
      }}
    >
      <TableCell padding="none" sx={{ width: 40, pl: 1 }}>
        <Checkbox
          checked={checked}
          onChange={onCheck}
          sx={{
            p: 0.5,
          }}
        />
      </TableCell>
      <TableCell sx={{ width: 50 }}>
        <Typography variant="body2" color="text.secondary" fontSize={13}>
          {part.unity}
        </Typography>
      </TableCell>
      <TableCell sx={{ maxWidth: 0 }}>
        <Typography
          variant="body2"
          fontSize={13}
          noWrap
          sx={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            display: "block",
          }}
        >
          {part.name}
        </Typography>
      </TableCell>
      <TableCell align="right" sx={{ width: 80 }}>
        <Typography variant="body2" fontSize={13}>
          {part.quantity ? formatNumber(part.quantity) : 0}
        </Typography>
      </TableCell>
      <TableCell align="right" sx={{ width: 100 }}>
        <Typography variant="body2" fontSize={13}>
          {formatCurrency(effectivePrice)}
        </Typography>
      </TableCell>
      <TableCell align="right" sx={{ width: 100 }}>
        <Typography variant="body2" fontWeight={500} fontSize={13}>
          {formatCurrency(total)}
        </Typography>
      </TableCell>
    </TableRow>
  )
}

Part.propTypes = {
  part: PropTypes.object.isRequired,
  selectedParts: PropTypes.array.isRequired,
  setSelectedParts: PropTypes.func.isRequired,
  priceField: PropTypes.string,
}

export default Part
